"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function WithPaymentLink(_ref) {
  var link = _ref.link;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": 'identification.new.with_link'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['label'],
      "data-locator": 'identification.new.with_link.label'
    }, "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      className: _defaultModule["default"]['text'],
      "data-locator": 'identification.new.with_link.text'
    }, "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u0441\u0447\u0435\u0442 \u0434\u043B\u044F \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u044F \u0443\u0440\u043E\u0432\u043D\u044F \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438"), !!link && /*#__PURE__*/_react["default"].createElement("a", {
      "data-locator": 'identification.new.with_link.link',
      className: _defaultModule["default"]['link'],
      rel: 'noopener noreferrer',
      target: '_blank',
      href: link
    }, "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441\u0447\u0435\u0442"));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

WithPaymentLink.defaultProps = {
  link: ''
};
var _default = WithPaymentLink;
exports["default"] = _default;